import { render, staticRenderFns } from "./Template4.vue?vue&type=template&id=fe46ce0e&scoped=true&"
import script from "./Template4.vue?vue&type=script&lang=js&"
export * from "./Template4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe46ce0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe46ce0e')) {
      api.createRecord('fe46ce0e', component.options)
    } else {
      api.reload('fe46ce0e', component.options)
    }
    module.hot.accept("./Template4.vue?vue&type=template&id=fe46ce0e&scoped=true&", function () {
      api.rerender('fe46ce0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/JVxeDemo/layout-demo/Template4.vue"
export default component.exports